import React, { useEffect, useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { PageHero } from '../components/PageHero';
import { ChevronDown, Send, CheckCircle } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface FaqItem {
  question: string;
  answer: string;
}
const faqItems: FaqItem[] = [{
  question: 'Як стати членом ФАіСУ?',
  answer: 'Для вступу до федерації потрібно зареєструватися на сайті через Google-акаунт, заповнити персональну інформацію в особистому кабінеті, завантажити підписану заяву та сплатити річний членський внесок. Після підтвердження оплати ви отримаєте статус дійсного члена ФАіСУ.'
}, {
  question: 'Який розмір річного членського внеску?',
  answer: 'Розмір членського внеску затверджується щорічно на засіданні президії. Актуальну інформацію про розмір внеску можна знайти в особистому кабінеті або уточнити за адресою office@umcf.org.ua.'
}, {
  question: 'Як отримати спортивний розряд з альпінізму або скелелазіння?',
  answer: 'Для присвоєння спортивного розряду необхідно виконати відповідні нормативи, зафіксовані в офіційних документах федерації. Подати заявку на присвоєння розряду можна через особистий кабінет, додавши підтверджуючі документи (протоколи змагань, маршрутні листи тощо).'
}, {
  question: 'Як взяти участь у змаганнях?',
  answer: 'Календар змагань публікується на початку кожного року в розділі «Новини». Для участі потрібно бути дійсним членом ФАіСУ, мати відповідний спортивний розряд (залежно від рівня змагань) та зареєструватися через систему онлайн-реєстрації.'
}, {
  question: 'Чи потрібна страховка для участі у заходах федерації?',
  answer: "Так, наявність спортивної страховки є обов'язковою умовою для участі у всіх офіційних заходах ФАіСУ — змаганнях, навчальних зборах та експедиціях. Члени федерації можуть скористатися спеціальними умовами страхування від наших партнерів."
}, {
  question: 'Як стати інструктором з альпінізму або скелелазіння?',
  answer: 'ФАіСУ щорічно проводить школи інструкторів. Для участі необхідно мати спортивний розряд не нижче КМС, досвід сходжень відповідної категорії та рекомендацію від регіональної федерації. Інформація про набір публікується в розділі «Новини».'
}, {
  question: 'Як створити регіональний відокремлений підрозділ?',
  answer: 'Для створення відокремленого підрозділу потрібно подати заявку до президії ФАіСУ з відповідним пакетом документів: протокол установчих зборів, список засновників (не менше 10 осіб), проєкт положення про підрозділ. Детальну інформацію можна отримати за адресою office@umcf.org.ua.'
}, {
  question: 'Де знайти офіційні документи федерації?',
  answer: 'Всі офіційні документи — статут, положення, протоколи засідань президії, фінансові звіти — доступні в розділі «Федерація» → «Документи» на нашому сайті.'
}, {
  question: "Як зв'язатися з федерацією?",
  answer: "Ви можете зв'язатися з нами за електронною адресою info@umcf.org.ua (загальні питання), office@umcf.org.ua (офіційне листування) або head@umcf.org.ua (президент федерації). Офіс розташований за адресою: Київ, вул. Є.Чавдар, 10 (м. Осокорки). Час роботи: Пн–Пт, 10:00–18:00."
}, {
  question: 'Чи визнається членство ФАіСУ на міжнародному рівні?',
  answer: 'Так. ФАіСУ є офіційним представником України в Міжнародному союзі альпіністських асоціацій (UIAA) та Міжнародній федерації спортивного скелелазіння (IFSC). Членство у ФАіСУ дає можливість брати участь у міжнародних змаганнях та програмах під егідою цих організацій.'
}];
const contactCategories = ['Членство', 'Змагання', 'Спортивні розряди', 'Страхування', 'Інструктори', 'Документи', 'Інше'];
function AccordionItem({
  item,
  isOpen,
  onToggle
}: {
  item: FaqItem;
  isOpen: boolean;
  onToggle: () => void;
}) {
  return <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-664">
      <button onClick={onToggle} className="w-full flex items-center justify-between px-6 py-5 text-left" data-id="element-665">
        <span className="text-sm font-bold text-primary pr-4" data-id="element-666">
          {item.question}
        </span>
        <ChevronDown className={`h-4 w-4 text-primary/40 flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-667" />
      </button>
      <AnimatePresence data-id="element-668">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="overflow-hidden" data-id="element-669">
            <div className="px-6 pb-5 border-t border-gray-100 pt-4" data-id="element-670">
              <p className="text-sm text-gray-600 leading-relaxed" data-id="element-671">
                {item.answer}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FaqPage() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    category: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
    setTimeout(() => {
      setIsSubmitted(false);
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        category: '',
        message: ''
      });
    }, 4000);
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-672">
      <Header data-id="element-673" />
      <main className="pt-20 pb-16" data-id="element-674">
        <PageHero label="Допомога" title="Часті запитання" subtitle="Відповіді на найпоширеніші запитання про діяльність федерації, членство та участь у заходах." data-id="element-675" />

        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-676">
          <div className="space-y-3" data-id="element-677">
            {faqItems.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.04,
            duration: 0.3
          }} data-id="element-678">
                <AccordionItem item={item} isOpen={openIndex === index} onToggle={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-679" />
              </motion.div>)}
          </div>

          {/* Contact Form */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="mt-16" data-id="element-680">
            <div className="text-center mb-8" data-id="element-681">
              <h2 className="text-2xl font-heading font-bold text-primary" data-id="element-682">
                Не знайшли відповідь?
              </h2>
              <p className="mt-2 text-sm text-gray-500" data-id="element-683">
                Надішліть своє запитання — ми відповімо якнайшвидше.
              </p>
            </div>

            <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6 sm:p-8" data-id="element-684">
              <AnimatePresence mode="wait" data-id="element-685">
                {isSubmitted ? <motion.div key="success" initial={{
                opacity: 0,
                scale: 0.95
              }} animate={{
                opacity: 1,
                scale: 1
              }} exit={{
                opacity: 0,
                scale: 0.95
              }} className="flex flex-col items-center justify-center py-12 text-center" data-id="element-686">
                    <CheckCircle className="h-12 w-12 text-green-500 mb-4" data-id="element-687" />
                    <h3 className="text-lg font-bold text-primary mb-2" data-id="element-688">
                      Повідомлення надіслано!
                    </h3>
                    <p className="text-sm text-gray-500" data-id="element-689">
                      Дякуємо за ваше звернення. Ми відповімо на вашу електронну
                      адресу.
                    </p>
                  </motion.div> : <motion.form key="form" initial={{
                opacity: 0
              }} animate={{
                opacity: 1
              }} exit={{
                opacity: 0
              }} onSubmit={handleSubmit} className="space-y-5" data-id="element-690">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-691">
                      <div data-id="element-692">
                        <label htmlFor="firstName" className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5" data-id="element-693">
                          Ім'я <span className="text-red-400" data-id="element-694">*</span>
                        </label>
                        <input id="firstName" type="text" required value={formData.firstName} onChange={e => setFormData({
                      ...formData,
                      firstName: e.target.value
                    })} className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-colors" placeholder="Ваше ім'я" data-id="element-695" />
                      </div>
                      <div data-id="element-696">
                        <label htmlFor="lastName" className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5" data-id="element-697">
                          Прізвище <span className="text-red-400" data-id="element-698">*</span>
                        </label>
                        <input id="lastName" type="text" required value={formData.lastName} onChange={e => setFormData({
                      ...formData,
                      lastName: e.target.value
                    })} className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-colors" placeholder="Ваше прізвище" data-id="element-699" />
                      </div>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-700">
                      <div data-id="element-701">
                        <label htmlFor="email" className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5" data-id="element-702">
                          Email <span className="text-red-400" data-id="element-703">*</span>
                        </label>
                        <input id="email" type="email" required value={formData.email} onChange={e => setFormData({
                      ...formData,
                      email: e.target.value
                    })} className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-colors" placeholder="email@example.com" data-id="element-704" />
                      </div>
                      <div data-id="element-705">
                        <label htmlFor="category" className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5" data-id="element-706">
                          Рубрика <span className="text-red-400" data-id="element-707">*</span>
                        </label>
                        <select id="category" required value={formData.category} onChange={e => setFormData({
                      ...formData,
                      category: e.target.value
                    })} className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-colors appearance-none bg-white" data-id="element-708">
                          <option value="" disabled data-id="element-709">
                            Оберіть рубрику
                          </option>
                          {contactCategories.map(cat => <option key={cat} value={cat} data-id="element-710">
                              {cat}
                            </option>)}
                        </select>
                      </div>
                    </div>

                    <div data-id="element-711">
                      <label htmlFor="message" className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5" data-id="element-712">
                        Повідомлення <span className="text-red-400" data-id="element-713">*</span>
                      </label>
                      <textarea id="message" required rows={5} value={formData.message} onChange={e => setFormData({
                    ...formData,
                    message: e.target.value
                  })} className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-colors resize-none" placeholder="Опишіть ваше запитання..." data-id="element-714" />
                    </div>

                    <div className="flex justify-end pt-2" data-id="element-715">
                      <button type="submit" className="inline-flex items-center px-6 py-2.5 bg-primary text-white text-sm font-semibold rounded-lg hover:bg-primary/90 transition-colors shadow-sm" data-id="element-716">
                        Надіслати
                        <Send className="ml-2 h-4 w-4" data-id="element-717" />
                      </button>
                    </div>
                  </motion.form>}
              </AnimatePresence>
            </div>
          </motion.div>
        </div>
      </main>
      <Footer data-id="element-718" />
    </div>;
}